import React, { useMemo, useCallback } from 'react';

import {
  HStack,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FormProvider } from 'react-hook-form';
import { useTable } from 'react-table';

import { Button, Input } from 'components';
import Item from 'containers/Table/Item';
import { PermissionTypes } from 'enums/types';

import { columns } from './constants';

export default function RoleTable({
  form, onSubmit, role, editable, setEditable,
}) {
  const { handleSubmit, register } = form;

  const {
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: useMemo(() => columns as any, [columns]),
    data: useMemo(() => role.permissions, [role]),
  });

  const Body = useCallback(() => (
    <Tbody>
      {rows.map((row) => {
        prepareRow(row);
        return (
          <Tr key={`row-${row.id}`}>
            {row.cells.map((cell) => (
              <Item
                {...cell.column}
                form={form}
                editable={editable}
                options={Object.values(PermissionTypes)}
                key={`row-${row.id}-${JSON.stringify(cell.value)}`}
                variant="SmallSemiBold"
                item={cell.value}
                original={row.original}
                cursor="pointer"
              />
            ))}
          </Tr>
        );
      })}
    </Tbody>
  ), [rows, editable]);

  const Keys = useCallback(() => (
    <Thead>
      {headerGroups.map((headerGroup) => (
        <Tr
          bg="gray.100"
          key={`header-${headerGroup.id}`}>
          {headerGroup.headers.map((column) => (
            <Th
              p={4}
              key={column.id}>
              <Text color="gray.500">{column.render('Header')}</Text>
            </Th>
          ))}
        </Tr>
      ))}
    </Thead>
  ), [headerGroups]);

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {editable && (
        <Input
          w={280}
          {...register('name')}
          label="Nome da Permissão"
        />
        )}
        <Table
          mt={6}
          bg="white"
          variant="simple">
          <Keys />
          <Body />
        </Table>
        <HStack
          mt={6}
          justify="flex-end"
          hidden={!editable}>
          <Button
            onClick={() => setEditable(false)}
            size="xs"
            variant="secondary.teal">
            <Text variant="smallBold">
              Cancelar
            </Text>
          </Button>
          <Button
            type="submit"
            size="xs"
            variant="primary.blue">
            <Text variant="smallBold">
              Salvar
            </Text>
          </Button>
        </HStack>
      </form>
    </FormProvider>
  );
}
